<template>
    <div class="dispositivos-registros">
        <h2>Registros - Dispositivos Médicos</h2>
        <div class="registros-content">
            <el-card>
                <div slot="header">
                    <span>Gestión de Registros de Dispositivos Médicos</span>
                </div>
                <el-table :data="registros" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>
                    <el-table-column prop="nombre" label="Nombre del Dispositivo"></el-table-column>
                    <el-table-column prop="tipo" label="Tipo"></el-table-column>
                    <el-table-column prop="fecha" label="Fecha de Registro"></el-table-column>
                    <el-table-column prop="estado" label="Estado"></el-table-column>
                    <el-table-column label="Acciones" width="150">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="editarRegistro(scope.row)">Editar</el-button>
                            <el-button size="mini" type="danger" @click="eliminarRegistro(scope.row)">Eliminar</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DispositivosRegistros',
    data() {
        return {
            registros: [
                { id: 1, nombre: 'Monitor Cardíaco', tipo: 'Monitoreo', fecha: '2024-01-15', estado: 'Activo' },
                { id: 2, nombre: 'Ventilador Mecánico', tipo: 'Respiración', fecha: '2024-01-16', estado: 'Mantenimiento' },
                { id: 3, nombre: 'Bomba de Infusión', tipo: 'Administración', fecha: '2024-01-17', estado: 'Inactivo' }
            ]
        }
    },
    methods: {
        editarRegistro(registro) {
            console.log('Editar registro:', registro)
        },
        eliminarRegistro(registro) {
            console.log('Eliminar registro:', registro)
        }
    }
}
</script>

<style lang="scss" scoped>
.dispositivos-registros {
    padding: 20px;
    
    h2 {
        color: var(--color-primary);
        margin-bottom: 30px;
        font-weight: 600;
    }
    
    .registros-content {
        .el-card {
            margin-bottom: 20px;
            border-radius: var(--radius-md);
            border: 1px solid var(--color-border);
            
            :deep(.el-card__header) {
                background-color: var(--color-surface-base);
                border-bottom: 1px solid var(--color-border);
                border-radius: var(--radius-md) var(--radius-md) 0 0;
                
                span {
                    color: var(--color-primary);
                    font-weight: 500;
                }
            }
            
            :deep(.el-table) {
                .el-table__header-wrapper {
                    .el-table__header {
                        th {
                            background-color: var(--color-surface-alt);
                            color: var(--color-primary);
                            font-weight: 500;
                        }
                    }
                }
                
                .el-table__body-wrapper {
                    .el-table__body {
                        td {
                            color: var(--color-surface-muted);
                        }
                    }
                }
            }
            
            :deep(.el-button--mini) {
                border-radius: var(--radius-sm);
                
                &.el-button--default {
                    background-color: var(--color-btn-primary);
                    border-color: var(--color-btn-primary);
                    color: white;
                    
                    &:hover {
                        background-color: var(--color-primary-hover);
                        border-color: var(--color-primary-hover);
                    }
                }
                
                &.el-button--danger {
                    background-color: var(--color-btn-danger);
                    border-color: var(--color-btn-danger);
                    
                    &:hover {
                        background-color: var(--color-feedback-error);
                        border-color: var(--color-feedback-error);
                    }
                }
            }
        }
    }
}
</style> 